import React from 'react'
import styles from './ConfettiCannon.sass'
import { SizeMe, SizeMeProps } from 'react-sizeme'
import { createConfetti, Confetti, ConfettiProps } from './confetti'

interface ConfettiCannonProps extends ConfettiProps {
  delay?: number
}

export default function ConfettiCannon(props: ConfettiCannonProps) {
  return (
    <SizeMe monitorHeight monitorWidth>
      {({ size }) => <Inner size={size} {...props}></Inner>}
    </SizeMe>
  )
}

function Inner(props: ConfettiCannonProps & SizeMeProps) {
  const canvasRef = React.useRef<HTMLCanvasElement | null>(null)
  const confettiRef = React.useRef<Confetti | null>(null)
  React.useEffect(() => {
    if (!canvasRef.current) {
      return
    }

    const confetti = (confettiRef.current = createConfetti(canvasRef.current))

    confetti.configure(props)
    confetti.start(props.delay)
    return () => {
      confetti.stop()
    }
  }, [])

  React.useEffect(() => {
    const confetti = confettiRef.current
    if (!confetti) {
      return
    }

    confetti.configure(props)
  })

  return (
    <div className={styles.root}>
      <canvas
        className={styles.canvas}
        width={props.size.width || 0}
        height={props.size.height || 0}
        ref={canvasRef}
      />
    </div>
  )
}
